"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface ScrollLineProps {
  children: React.ReactNode;
  className?: string;
  "data-index"?: number;
}
function ScrollLine({
  children,
  className = "",
  "data-index": dataIndex
}: ScrollLineProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: false,
    rootMargin: "-20% 0px -20% 0px",
    threshold: 0
  });
  return <div data-section-id="146884" ref={ref as React.RefObject<HTMLDivElement>} data-index={dataIndex} className={`transition-opacity duration-1000 ease-out w-full flex justify-center gap-2 ${isVisible ? "opacity-100" : "opacity-40"} ${className}`}>
      {children}
    </div>;
}
export default function OurCorePhilosophy() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: false,
    rootMargin: "-20% 0px -20% 0px",
    threshold: 0
  });
  return <section ref={containerRef as React.RefObject<HTMLElement>} className="relative overflow-hidden py-24 px-8 md:px-12 lg:px-16 bg-gradient-to-b from-[#060f1a] to-[#0d1b2a]">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-gradient-to-r from-transparent via-[rgba(0,196,180,0.12)] to-transparent rounded-full blur-3xl pointer-events-none opacity-60 animate-pulse" />
      
      {}
      <div className="absolute inset-0 bg-repeat pointer-events-none opacity-10" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(0,196,180,0.015) 3px, rgba(0,196,180,0.015) 4px)'
    }} />

      {}
      <div className="relative z-10 max-w-5xl mx-auto">
        
        {}
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-40 translate-y-8'}`}>
          <div className="text-center mb-16">
            <h2 className="font-['Bebas_Neue'] text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-wide mb-2 leading-tight">
              NO RETAINERS.
            </h2>
            <h2 className="font-['Bebas_Neue'] text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-wide leading-tight">
              NO SURPRISES.
            </h2>
          </div>
        </div>

        {}
        <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-40 translate-y-8'}`}>
          <div className="mb-12">
            <p className="text-center font-['Bebas_Neue'] text-xl md:text-2xl text-white/70 tracking-wider mb-12 uppercase">
              We Deliver Through
            </p>
            
            {}
            <div className="grid grid-cols-3 gap-8 md:gap-6 mb-12 relative">
              {}
              <div className="absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#00c4b4] to-transparent hidden md:block" />
              
              {}
              <div className={`flex flex-col items-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-40 translate-y-8'}`} style={{
              transitionDelay: isVisible ? '0.4s' : '0s'
            }}>
                <div className="w-20 h-20 rounded-full border border-[rgba(0,196,180,0.3)] bg-[rgba(0,196,180,0.08)] flex items-center justify-center mb-4 transition-all hover:border-[#00c4b4] hover:bg-[rgba(0,196,180,0.18)] hover:scale-110 group">
                  <svg className="w-8 h-8 stroke-[#00c4b4]" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2M9 4a2 2 0 012-2h2a2 2 0 012 2v0a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <p className="text-[#00c4b4] font-['Bebas_Neue'] text-xs tracking-widest uppercase mb-2">Step 01</p>
                <p className="text-white/70 font-bold text-sm text-center leading-tight">Define Deliverables</p>
              </div>

              {}
              <div className={`flex flex-col items-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-40 translate-y-8'}`} style={{
              transitionDelay: isVisible ? '0.6s' : '0s'
            }}>
                <div className="w-20 h-20 rounded-full border border-[rgba(0,196,180,0.3)] bg-[rgba(0,196,180,0.08)] flex items-center justify-center mb-4 transition-all hover:border-[#00c4b4] hover:bg-[rgba(0,196,180,0.18)] hover:scale-110 group">
                  <svg className="w-8 h-8 stroke-[#00c4b4]" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                  </svg>
                </div>
                <p className="text-[#00c4b4] font-['Bebas_Neue'] text-xs tracking-widest uppercase mb-2">Step 02</p>
                <p className="text-white/70 font-bold text-sm text-center leading-tight">Milestone Payments</p>
              </div>

              {}
              <div className={`flex flex-col items-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-40 translate-y-8'}`} style={{
              transitionDelay: isVisible ? '0.8s' : '0s'
            }}>
                <div className="w-20 h-20 rounded-full border border-[rgba(0,196,180,0.3)] bg-[rgba(0,196,180,0.08)] flex items-center justify-center mb-4 transition-all hover:border-[#00c4b4] hover:bg-[rgba(0,196,180,0.18)] hover:scale-110 group">
                  <svg className="w-8 h-8 stroke-[#00c4b4]" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <p className="text-[#00c4b4] font-['Bebas_Neue'] text-xs tracking-widest uppercase mb-2">Step 03</p>
                <p className="text-white/70 font-bold text-sm text-center leading-tight">Guaranteed Outcomes</p>
              </div>
            </div>

            {}
            <div className="text-center mb-6">
              <p className="font-['Bebas_Neue'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#00c4b4] tracking-wider uppercase">
                MILESTONE-BASED
              </p>
              <p className="font-['Bebas_Neue'] text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-wider uppercase">
                ENGAGEMENT MODELS
              </p>
            </div>
          </div>

          {}
          <div className="w-64 h-px bg-gradient-to-r from-transparent via-[#00c4b4] to-transparent mx-auto my-8" />

          {}
          <div className="text-center mt-12">
            <p className="font-['Bebas_Neue'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#00c4b4] tracking-wider uppercase leading-tight">
              ENSURING ABSOLUTE
            </p>
            <p className="font-['Bebas_Neue'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#00c4b4] tracking-wider uppercase leading-tight">
              PRECISION
            </p>
            <p className="font-['Bebas_Neue'] text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-wider uppercase leading-tight">
              IN EVERY OUTCOME.
            </p>
          </div>

          {}
          <div className={`text-center mt-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
          transitionDelay: isVisible ? '1.2s' : '0s'
        }}>
            <p className="text-xs md:text-sm font-medium tracking-widest text-white/70 uppercase">
              Every engagement begins with a signed Statement of Work. Nothing is verbal. Nothing is assumed.
            </p>
          </div>
        </div>
      </div>
    </section>;
}